import { getApps, initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
	apiKey: "AIzaSyBCRSc0nOEBIAnLJ9jZHezjrxKXnb4WFcI",
	authDomain: "auth.onsand.app",
	projectId: "sideout-5875e",
	storageBucket: "sideout-5875e.firebasestorage.app",
	messagingSenderId: "676198476995",
	appId: "1:676198476995:web:38c9b8fe8d5d60740e8676",
};

const app =
	getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
export const auth = getAuth(app);
